<script setup lang="ts">
    import type { Company } from '@/types';
    import CustomerDashboardContact from './CustomerDashboardContact.vue';

    const props = defineProps<{
        company: Company;
    }>();
</script>

<template>
    <CustomerDashboardContact
        v-if="company.primary_employee"
        :employee="company.primary_employee"
    />
    <CustomerDashboardContact
        v-if="company.assistant"
        :employee="company.assistant"
    />
</template>
